/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: external-metadata-service
 *
 * Created by rwilliams on 10/5/17.
 */
'use strict';
angular.module('prism-ui.externalMetadata').service('ExternalMetadataService', function (
    _,
    AggregationResourceFactory,
    ExternalMetadataLoggingResourceFactory,
    UtilsService
) {
	const self = this;

	self.editorForm = null;

	self.getExternalSources = () => AggregationResourceFactory.query().$promise;

	self.getExternalSource = (externalSourceId) => AggregationResourceFactory.get({id: externalSourceId}).$promise;

	self.getExternalSourceType = (externalSource) => {
        if (_.has(externalSource, 'watchFolderPath')) {
            return UtilsService.externalIngestTypes.watchFolder;
        } else {
            return UtilsService.externalIngestTypes.jsonFeed;
        }
    };

	self.saveUpdateMetadataSource = (requestMethod, editData) => AggregationResourceFactory[requestMethod](editData).$promise;

	self.runMetadataSource = (externalSourceId, filename, externalIngestXml) => {
        return AggregationResourceFactory.run(
            {
                id: externalSourceId,
                filename: filename,
            },
            externalIngestXml).$promise;
    };

	self.getExternalMetadataLogging = (queryParams, queryHandler) => ExternalMetadataLoggingResourceFactory.query(queryParams, queryHandler).$promise;
});
